
<!-- Reusable upload-on-select status indicator (FR1/FR5). Pass the control name as context. -->
<ng-template #uploadStatus let-c>
  <div class="mt-1" *ngIf="uploadState[c]">
    <span *ngIf="uploadState[c] === 'uploading'" class="text-secondary small"><i class="fa fa-spinner fa-spin"></i> Uploading…</span>
    <span *ngIf="uploadState[c] === 'uploaded'" class="text-success small"><i class="fa fa-check-circle"></i> Uploaded</span>
    <span *ngIf="uploadState[c] === 'error'" class="text-danger small"><i class="fa fa-times-circle"></i> {{ uploadError[c] || 'Upload failed — please re-select the file.' }}</span>
  </div>
</ng-template>

<div class="row">

  <form *ngIf="formResetToggle" class="login" name="loginForm"
        [formGroup]="icdForm" (ngSubmit)="onSubmit()" novalidate>



        <div class="row">
          <div class="col-sm-4">
            <div class="form-check mb-3">
              <input type="radio" formControlName="US_or_CA" value="US" id="US_or_CA" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />

              <label for="acceptTerms" class="form-check-label">US</label><br />
              <input type="radio" formControlName="US_or_CA" value="Canada" id="US_or_CA" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />
              <label for="acceptTerms" class="form-check-label">Canada  <code>*</code></label>
              <div *ngIf="submitted && f.US_or_CA.errors" class="invalid-feedback">US or Canada is required</div>
            </div>
          </div>

        </div>


        <div class="card card-secondary">
          <div class="card-header">
            <h3 class="card-title">
              ICD Info
            </h3>

            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>

          <div class="card-body">


            <div class="row">
              <div class="col-sm-4">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Distributor_Code">Distributor Code <code>*</code></label>
                  <input type="text" formControlName="Distributor_Code" class="form-control"
                          placeholder="Enter Full Distributor_Code"
                          appAiHint="Distributor Code" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.Distributor_Code.errors" class="invalid-feedback">
                    <div *ngIf="f.Distributor_Code.errors.required">Distributor_Code  is required</div>
                  </div>

                </div>




              </div>
              <div class="col-sm-4">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Full_Legal_Company_Name">ICD Corporation Name <code>*</code></label>
                  <input type="text" formControlName="Full_Legal_Company_Name" class="form-control"
                          placeholder="Enter Full Legal Company Name"
                          appAiHint="Full Legal Company Name" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.Full_Legal_Company_Name.errors" class="invalid-feedback">
                    <div *ngIf="f.Full_Legal_Company_Name.errors.required">Full Legal Company Name  is required</div>
                  </div>

                </div>




              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-ICD_Owner_Name">ICD Owner's Name <code>*</code></label>
                  <input type="text" formControlName="ICD_Owner_Name" class="form-control"
                         
                         placeholder="Enter  Owner  Name"
                         appAiHint="ICD Owner Name" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.ICD_Owner_Name.errors" class="invalid-feedback">
                    <div *ngIf="f.ICD_Owner_Name.errors.required">Owner  Name is required</div>
                  </div>

                </div>
              </div>

              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-HUB_Manager_Contact_Name">Hub Name<code>*</code></label>
                  <div class="col-md-12">
                    <input type="text" formControlName="HUB_Manager_Contact_Name" id="login-HUB_Manager_Contact_Name" name="HUB_Manager_Contact_Name" placeholder="Enter Hub Name" autocomplete="HUB_Manager_Contact_Name"
                           class="form-control"
                           appAiHint="HUB Manager Contact Name" [aiHintForm]="icdForm" />

                  </div>
                </div>
              </div>

              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Promoting_Owner">Promoting Owner<code>*</code></label>
                  <div class="col-md-12">
                    <ng-select [searchable]="true" formControlName="Promoting_Owner" (change)="onCheckboxPo($event)">
                      <ng-option *ngFor="let o of PO_namesData"
                                 [value]="o.ownerName">
                        {{ o.ownerNameCompany }}
                      </ng-option>
                    </ng-select>

                    <div *ngIf="submitted && f.Promoting_Owner.errors" class="invalid-feedback">
                      <div *ngIf="f.Promoting_Owner.errors.required">Promoting Owner is required</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Promoting_Owner">Promoting Owner's Company<code>*</code></label>
                  <div class="col-md-12">
                    <input type="text" formControlName="Promoting_Owner_Company" class="form-control"
                           [ngClass]="{'is-valid': f.Promoting_Owner_Company.valid, 'is-invalid' : submitted && f.Promoting_Owner_Company.valid}" placeholder="Enter Promoting Owner Company"
                           appAiHint="Promoting Owner Company" [aiHintForm]="icdForm" />
                    <div *ngIf="submitted && f.Promoting_Owner_Company.errors" class="invalid-feedback">
                      <div *ngIf="f.Promoting_Owner_Company.errors.required">Promoting  Company is required</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Regional_Consultant">Regional Consultant</label>
                  <div class="col-md-12">

                    <ng-select [searchable]="true" formControlName="Regional_Consultant"
                               (change)="onCheckboxRC($event)">
                      <ng-option *ngFor="let o of RC_namesData"
                                 [value]="o.ownerName">
                        {{ o.ownerNameCompany }}
                      </ng-option>
                    </ng-select>
                    <div *ngIf="submitted && f.Regional_Consultant.errors" class="invalid-feedback">
                      <div *ngIf="f.Regional_Consultant.errors.required">Regional Consultant is required</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Regional_Consultant">Regional Consultant's Company</label>
                  <div class="col-md-12">
                    <input type="text" formControlName="Regional_Consultant_Company" class="form-control"
                           [ngClass]="{'is-valid': f.Regional_Consultant_Company.valid, 'is-invalid' : submitted && f.Regional_Consultant_Company.valid}" placeholder="Enter Regional Consultant Company"
                           appAiHint="Regional Consultant Company" [aiHintForm]="icdForm" />
                    <div *ngIf="submitted && f.Regional_Consultant_Company.errors" class="invalid-feedback">
                      <div *ngIf="f.Regional_Consultant_Company.errors.required">Regional Consultant Company is required</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-National_Consultant">National Consultant<code>*</code></label>
                  <div class="col-md-12">

                    <ng-select [searchable]="true" formControlName="National_Consultant" [ngClass]="{ 'is-invalid': submitted && f.National_Consultant.errors }"
                               (change)="onCheckboxNC($event)">
                      <ng-option *ngFor="let o of NC_namesData"
                                 [value]="o.ownerName">
                        {{ o.ownerNameCompany }}
                      </ng-option>
                    </ng-select>

                    <div *ngIf="submitted && f.National_Consultant.errors" class="invalid-feedback">
                      <div *ngIf="f.National_Consultant.errors.required">National Consultant is required</div>
                    </div>
                  </div>
                </div>
              </div>



            </div>

          </div>

        </div>




        <div class="card card-secondary ">
          <div class="card-header">
            <h3 class="card-title"> ADD Campaign(s) (Check all the apply) </h3>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>

          <div class="card-body">
            <div class="row" *ngIf="selectedCountry == 'Canada'">
              <span>Select all Campaigns that apply.</span>
              <div class="col-md-4" *ngFor="let item of Canada_campaignData">
                <div class="form-group">
                  <div class="custom-control custom-switch  custom-switch-on-success">
                    <input type="checkbox" class="custom-control-input" [id]="item.id" [value]="item.campaignName"
                           [disabled]="isCheckboxesDisabled" [checked]="Canada_Campaigns_selectedItems.includes(item.campaignName)"
                           (change)="onCheckboxChange_Canada_Campaigns($event, item.campaignName)">
                    <label class="custom-control-label" [for]="item.id">{{ item.campaignName }}</label>
                  </div>
                </div>

              </div>
              
            </div>
            <div class="row" *ngIf="selectedCountry == 'Canada'">
              <span>Select all Due Diligence Campaigns that apply.</span>
              <div class="col-md-4" *ngFor="let item of Canada_campaignData_DD">
                <div class="form-group">
                  <div class="custom-control custom-switch  custom-switch-on-success">
                    <input type="checkbox" class="custom-control-input" [id]="item.id" [value]="item.campaignName"
                           [disabled]="isCheckboxesDisabled" [checked]="Canada_Campaigns_selectedItems.includes(item.campaignName)"
                           (change)="onCheckboxChange_Canada_Campaigns($event, item.campaignName)">
                    <label class="custom-control-label" [for]="item.id">{{ item.campaignName }}</label>
                  </div>
                </div>

              </div>
              <span *ngIf="Canada_Campaigns_isSelectedItemsinvalid" style="color:red;">at least select one option in Campaigns</span>
            </div>
            <div class="row" *ngIf="selectedCountry == 'US'">
              <span>Select all Campaigns that apply.</span>
              <div class="col-md-4" *ngFor="let item of US_campaignData">
                <div class="form-group">
                  <div class="custom-control custom-switch  custom-switch-on-success">
                    <input type="checkbox" class="custom-control-input" [id]="item.id"
                           [disabled]="isCheckboxesDisabled" [checked]="US_Campaigns_selectedItems.includes(item.campaignName)"
                           [value]="item.campaignName" (change)="onCheckboxChange_US_Campaigns($event, item.campaignName)">
                    <label class="custom-control-label" [for]="item.id">{{ item.campaignName }}</label>
                  </div>
                </div>

              </div>
              <span *ngIf="US_Campaigns_isSelectedItemsinvalid" style="color:red;"></span>
            </div>
            <div class="row" *ngIf="selectedCountry == 'US'">
              <span>Select all Due Diligence Campaigns that apply.</span>
              <div class="col-md-4" *ngFor="let item of US_campaignData_DD">
                <div class="form-group">
                  <div class="custom-control custom-switch  custom-switch-on-success">
                    <input type="checkbox" class="custom-control-input" [id]="item.id"
                           [disabled]="isCheckboxesDisabled" [checked]="US_Campaigns_selectedItems.includes(item.campaignName)"
                           [value]="item.campaignName" (change)="onCheckboxChange_US_Campaigns($event, item.campaignName)">
                    <label class="custom-control-label" [for]="item.id">{{ item.campaignName }}</label>
                  </div>
                </div>

              </div>
              <span *ngIf="US_Campaigns_isSelectedItemsinvalid" style="color:red;"></span>
            </div>
            <div class="col-sm-4" *ngIf="isTestCampaign">
              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-TestCampaignNotListed">TestCampaign(NotListed) <code>*</code></label>
                <input type="text" formControlName="TestCampaignNotListed" class="form-control" [attr.maxlength]="fieldMaxLengths.TestCampaignNotListed"
                       [ngClass]="{'is-valid': f.TestCampaignNotListed.valid, 'is-invalid' : submitted && !f.TestCampaignNotListed.valid}" placeholder="Enter  TestCampaignNotListed"
                       appAiHint="Test Campaign Not Listed" [aiHintForm]="icdForm" />
                <div class="text-right small mt-1"
                     [ngClass]="{'text-danger': f.TestCampaignNotListed.errors?.maxlength,'text-muted': !f.TestCampaignNotListed.errors?.maxlength}">

                  {{ icdForm.get('TestCampaignNotListed')?.value?.length || 0 }}/{{ fieldMaxLengths.TestCampaignNotListed }}

                </div>
                <div *ngIf="submitted && f.TestCampaignNotListed.errors" class="invalid-feedback">
                  <div *ngIf="f.TestCampaignNotListed.errors.required">Test Campaign Not Listed is required</div>
                  <div *ngIf="f.TestCampaignNotListed.errors.maxlength">
                    Maximum {{ fieldMaxLengths.TestCampaignNotListed }} characters allowed
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>

        <div class="card card-secondary ">
          <div class="card-header">
            <h3 class="card-title">Remove Campaign(s) (Check all the apply) </h3>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>

          <div class="card-body">
            <div class="row" *ngIf="selectedCountry == 'Canada'">
              <span>Select all Campaigns that apply.</span>
              <div class="col-md-4" *ngFor="let item of Canada_campaignData_R">
                <div class="form-group">
                  <div class="custom-control custom-switch  custom-switch-on-success">
                    <input type="checkbox" class="custom-control-input" [id]="item.id" [value]="item.campaignName"
                           [disabled]="isCheckboxesDisabled"    [checked]="Canada_Campaigns_selectedItems_R.includes(item.campaignName)"
                           (change)="onCheckboxChange_Canada_Campaigns_R($event, item.campaignName)">
                    <label class="custom-control-label" [for]="item.id">{{ item.campaignName }}</label>
                  </div>
                </div>

              </div>
              <!--<span *ngIf="Canada_Campaigns_isSelectedItemsinvalid_R" style="color:red;">at least select one option in Campaigns</span>-->
            </div>
            <div class="row" *ngIf="selectedCountry == 'US'">
              <span>Select all Campaigns that apply.</span>
              <div class="col-md-4" *ngFor="let item of US_campaignData_R">
                <div class="form-group">
                  <div class="custom-control custom-switch  custom-switch-on-success">
                    <input type="checkbox" class="custom-control-input" [id]="item.id"
                             [disabled]="isCheckboxesDisabled"   [checked]="US_Campaigns_selectedItems_R.includes(item.campaignName)" 
                           [value]="item.campaignName" (change)="Remove_onCheckboxChange_US_Campaigns_R($event, item.campaignName)">
                    <label class="custom-control-label" [for]="item.id">{{ item.campaignName }}</label>
                  </div>
                </div>

              </div>
              <span *ngIf="US_Campaigns_isSelectedItemsinvalid_R" style="color:red;"></span>
            </div>
            <div class="col-sm-4" *ngIf="isTestCampaign_R">
              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-TestCampaignNotListed_R">TestCampaign(NotListed) <code>*</code></label>
                <input type="text" formControlName="TestCampaignNotListed_R" class="form-control" [attr.maxlength]="fieldMaxLengths.TestCampaignNotListed_R"
                       [ngClass]="{'is-valid': f.TestCampaignNotListed_R.valid, 'is-invalid' : submitted && !f.TestCampaignNotListed_R.valid}" placeholder="Enter  TestCampaignNotListed"
                       appAiHint="Remove Test Campaign" [aiHintForm]="icdForm" />
                <div class="text-right small mt-1"
                     [ngClass]="{'text-danger': f.TestCampaignNotListed_R.errors?.maxlength,'text-muted': !f.TestCampaignNotListed_R.errors?.maxlength}">

                  {{ icdForm.get('TestCampaignNotListed_R')?.value?.length || 0 }}/{{ fieldMaxLengths.TestCampaignNotListed_R }}

                </div>
                <div *ngIf="submitted && f.TestCampaignNotListed_R.errors" class="invalid-feedback">
                  <div *ngIf="f.TestCampaignNotListed_R.errors.required">Test Campaign Not Listed is required</div>
                  <div *ngIf="f.TestCampaignNotListed_R.errors.maxlength">
                    Maximum {{ fieldMaxLengths.TestCampaignNotListed_R }} characters allowed
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>


        <div class="card card-secondary">
          <div class="card-header">
            <h3 class="card-title">
              Documents
            </h3>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>

          <div class="card-body">


            <div class="row">
              <div class="col-sm-6">


                <div class="form-group">
                  <label class="col-form-label col-md-12" for="login-Attach_US_Insurance_Application">Insurance Application (If Necessary)</label>
                  <input type="file" formControlName="Attach_US_Insurance_Application" (change)="onFileSelected($event, 'Attach_US_Insurance_Application')"
                         class="form-control"
                         [ngClass]="{'is-valid': f.Attach_US_Insurance_Application.valid && f.Attach_US_Insurance_Application.value, 'is-invalid' : submitted && !f.Attach_US_Insurance_Application.valid}" 
                         [class.is-invalid]="isInvalid('Attach_US_Insurance_Application')" />
                  <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_US_Insurance_Application' }"></ng-container>
                  <div class="invalid-feedback" *ngIf="isInvalid('Attach_US_Insurance_Application')">
                    <div *ngIf="icdForm.get('Attach_US_Insurance_Application').errors.required">Insurance Application is required</div>
                    <div *ngIf="icdForm.get('Attach_US_Insurance_Application').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                    <div *ngIf="icdForm.get('Attach_US_Insurance_Application').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                    <div *ngIf="icdForm.get('Attach_US_Insurance_Application').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                  </div>


                </div>
                <div *ngIf="verificationState['Attach_US_Insurance_Application'] === 'verifying'" class="mt-1 text-muted small">
                  <i class="fas fa-spinner fa-spin"></i> Verifying document...
                </div>
                <div *ngIf="verificationState['Attach_US_Insurance_Application'] === 'pass'" class="mt-1 text-success small">
                  <i class="fas fa-check-circle"></i> Document verified
                </div>
                <div *ngIf="verificationState['Attach_US_Insurance_Application'] === 'warn'" class="mt-1 text-warning small">
                  <i class="fas fa-exclamation-triangle"></i> Verification warning
                  <ul class="mb-0 pl-3">
                    <li *ngFor="let issue of verificationIssues['Attach_US_Insurance_Application']">{{issue}}</li>
                  </ul>
                </div>
                <div *ngIf="verificationState['Attach_US_Insurance_Application'] === 'warn_disabled_never_shown'" class="mt-1 text-warning small">
                  <i class="fas fa-exclamation-triangle"></i> Verification failed
                  <ul class="mb-0 pl-3">
                    <li *ngFor="let issue of verificationIssues['Attach_US_Insurance_Application']">{{issue}}</li>
                  </ul>
                </div>

              </div>
              <div class="col-sm-6 hide">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Node_Form">Node Form</label>
                  <input type="file" formControlName="Node_Form" class="form-control"
                         [ngClass]="{'is-valid': f.Node_Form.valid && f.Node_Form.value, 'is-invalid' : submitted && !f.Node_Form.valid}" 
                         (change)="onFileSelected($event, 'Node_Form')" />
                  <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Node_Form' }"></ng-container>

                  <div class="invalid" style="color:red !important" *ngIf="isInvalid('Node_Form')">
                    <div *ngIf="icdForm.get('Node_Form').errors.required">Node Form is required</div>
                    <div *ngIf="icdForm.get('Node_Form').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                    <div *ngIf="icdForm.get('Node_Form').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                    <div *ngIf="icdForm.get('Node_Form').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                  </div>

                </div>
              </div>






            </div>



          </div>

        </div>



      <!-- AI Pre-Submit Review Modal -->
      <app-pre-submit-review
        [visible]="showPreSubmitReview"
        [issues]="preSubmitIssues"
        [loading]="preSubmitLoading"
        (dismiss)="onPreSubmitDismiss()"
        (submitAnyway)="onPreSubmitDoSubmit()"
        (recheck)="onPreSubmitRecheck()"
        (autoFix)="onPreSubmitAutoFix($event)"
        (navigateToField)="onPreSubmitNavigate($event)">
      </app-pre-submit-review>
        <div class="mb-3" *ngIf="btnDisplay">


          <button type="submit" class="btn btn-success float-right">
            {{isLoading ? 'Submit' : 'Submit'}}

          </button>


        </div>

  </form>

</div>

